import { PagingInfo } from "../../../utils/Grid";
import { acquireAccessToken } from "../../../index";
import axios from "axios";
import {ControlListValueFetchSearchCriteria} from "./ControlListValue";

export interface CriteriaAndPaging {
    criteria?: ControlListValueFetchSearchCriteria,
    paging?: PagingInfo,
}

export async function fetchAll(query: CriteriaAndPaging) {
    const token = await acquireAccessToken();
    return await axios.get('/api/ControlLists/Values', {
        headers: {
            authorization: `Bearer ${token}`,
        },
        params: { ...query.criteria, ...query.paging },
    });
}
